// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__37z7w","label":"CategoryService_label__1xAS8","location":"CategoryService_location__JuJOv"};